/**
 * Build conversation turns for AI Hiring candidate detail modal.
 * Prefers phoneInterviewConversation from API; falls back to legacy fields.
 */

const firstNonEmpty = (...vals) => {
  for (const v of vals) {
    const s = String(v ?? "").trim();
    if (s) return s;
  }
  return "";
};

const normalizeRole = (raw = "") => {
  const value = String(raw).toLowerCase();
  if (
    value.includes("agent") ||
    value.includes("assistant") ||
    value.includes("ai") ||
    value.includes("bot") ||
    value.includes("interviewer")
  ) {
    return "ai";
  }
  if (
    value.includes("user") ||
    value.includes("candidate") ||
    value.includes("applicant") ||
    value.includes("human") ||
    value.includes("caller")
  ) {
    return "applicant";
  }
  if (value.includes("system")) return "system";
  return "unknown";
};

export const roleLabelForTurn = (role) => {
  if (role === "ai") return "Albert AI";
  if (role === "applicant") return "Applicant";
  if (role === "system") return "System";
  return "Speaker";
};

export function getPhoneConversationTurns(candidate) {
  if (!candidate) return [];

  if (Array.isArray(candidate.phoneInterviewConversation)) {
    return candidate.phoneInterviewConversation
      .map((turn) => ({
        role: turn?.role || "unknown",
        label: turn?.label || roleLabelForTurn(turn?.role),
        text: firstNonEmpty(turn?.text),
      }))
      .filter((turn) => turn.text);
  }

  const interviewQA = candidate.phoneInterviewQA;
  if (Array.isArray(interviewQA) && interviewQA.length > 0) {
    const turns = [];
    interviewQA.forEach((entry) => {
      const question = firstNonEmpty(entry?.question);
      const answer = firstNonEmpty(entry?.answer);
      if (question) {
        turns.push({ role: "ai", label: "Albert AI", text: question });
      }
      if (answer) {
        turns.push({ role: "applicant", label: "Applicant", text: answer });
      }
    });
    if (turns.length > 0) return turns;
  }

  const entries = candidate.phoneInterviewTranscriptEntries;
  if (Array.isArray(entries) && entries.length > 0) {
    const turns = [];
    entries.forEach((entry) => {
      const question = firstNonEmpty(entry?.questionText);
      const answer = firstNonEmpty(entry?.text);
      if (question) {
        turns.push({ role: "ai", label: "Albert AI", text: question });
      }
      if (answer) {
        turns.push({ role: "applicant", label: "Applicant", text: answer });
      }
    });
    if (turns.length > 0) return turns;
  }

  const transcript = firstNonEmpty(candidate.phoneInterviewTranscript);
  if (!transcript) return [];

  return transcript
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const match = line.match(/^([^:]+):\s*(.+)$/);
      if (match) {
        const role = normalizeRole(match[1]);
        return {
          role,
          label: roleLabelForTurn(role),
          text: match[2].trim(),
        };
      }
      return { role: "unknown", label: "Transcript", text: line };
    });
}
